// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Belt_Array = require("bs-platform/lib/js/belt_Array.js");
var Plate$BwaxAdmin = require("../../../plate.bs.js");
var Lang_eval$BwaxAdmin = require("../../lang_eval.bs.js");
var Caml_chrome_debugger = require("bs-platform/lib/js/caml_chrome_debugger.js");
var Runtime_common$BwaxAdmin = require("../runtime_common.bs.js");

var module_name = "Array";

var src = "\nmodule " + (String(module_name) + ";\n\n-- Return an empty array.\nempty: () -> Array a = external;\n\n-- Initialize an array. initialize n f creates an array of length n with the element at index i initialized to the result of (f i).\ninitialize : Int -> (Int -> a) -> Array a = external;\n\n-- Creates an array with a given length, filled with a default element.\nrepeat : Int -> a -> Array a = external;\n\n-- Create an array from a List.\nfromList : List a -> Array a = external;\n\n\n-- Determine if an array is empty.\nisEmpty : Array a -> Bool = external;\n\n-- Return the length of an array.\nlength : Array a -> Int = external;\n\n-- Return Just the element at the index or Nothing if the index is out of range.\nget : Int -> Array a -> Maybe a = external;\n\n-- Set the element at a particular index. Returns an updated array. If the index is out of range, the array is unaltered.\nset : Int -> a -> Array a -> Array a = external;\n\n-- Push an element onto the end of an array.\npush : a -> Array a -> Array a = external;\n\n-- Append two arrays to a new one.\nappend : Array a -> Array a -> Array a = external;\n\n-- Get a sub-section of an array: (slice start end array). \n-- The start is a zero-based index where we will start our slice. \n-- The end is a zero-based index that indicates the end of the slice. \n-- The slice extracts up to but not including end.\n-- Both the start and end indexes can be negative, indicating an offset from the end of the array.\n-- This makes it pretty easy to pop the last element off of an array: slice 0 -1 array\nslice : Int -> Int -> Array a -> Array a = external;\n\n\n-- Create a list of elements from an array.\ntoList : Array a -> List a = external;\n\n-- Create an indexed list from an array. Each element of the array will be paired with its index.\ntoIndexedList : Array a -> List ( Int, a ) = external;\n\n\n-- Apply a function on every element in an array.\nmap : (a -> b) -> Array a -> Array b = external;\n\n-- Apply a function on every element with its index as first argument.\nindexedMap : (Int -> a -> b) -> Array a -> Array b = external;\n\n-- Reduce an array from the left. Read foldl as fold from the left.\nfoldl : (acc -> a -> acc) -> acc -> Array a -> acc = external;\n\n-- Reduce an array from the right. Read foldr as fold from the right.\nfoldr : (a -> init -> init) -> Array a -> init -> init = external;\n\n-- Keep elements that pass the test.\nfilter : (a -> Bool) -> Array a -> Array a = external;\n\n\n");

function invalid_args(name) {
  throw [
        Lang_eval$BwaxAdmin.Eval_exn,
        module_name + ("." + (name + ": Invalid Arguments"))
      ];
}

function pack_array(array) {
  return /* tuple */[
          /* V_array */Caml_chrome_debugger.variant("V_array", 12, [array]),
          Runtime_common$BwaxAdmin.nt
        ];
}

function pack_proc(f) {
  return (function (v) {
      return Lang_eval$BwaxAdmin.apply_value(module_name, f, v, Runtime_common$BwaxAdmin.nt);
    });
}

function pack_predicate(f) {
  return (function (k) {
      var result = Lang_eval$BwaxAdmin.apply_value_args(module_name, f, /* :: */Caml_chrome_debugger.simpleVariant("::", [
              k,
              /* [] */0
            ]), Runtime_common$BwaxAdmin.nt);
      var match = result[0];
      if (typeof match === "number" || match.tag !== /* V_literal */5) {
        return invalid_args("predicate");
      } else {
        var match$1 = match[0];
        if (typeof match$1 === "number" || match$1.tag !== /* Bool */4) {
          return invalid_args("predicate");
        } else {
          return match$1[0];
        }
      }
    });
}

var external_vals_000 = /* tuple */[
  "empty",
  Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
          return /* tuple */[
                  /* V_array */Caml_chrome_debugger.variant("V_array", 12, [/* array */[]]),
                  Runtime_common$BwaxAdmin.nt
                ];
        }))
];

var external_vals_001 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    /* tuple */[
      "initialize",
      Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
              if (param) {
                var match = param[0][0];
                if (typeof match === "number" || match.tag !== /* V_literal */5) {
                  return invalid_args("initialize");
                } else {
                  var match$1 = match[0];
                  if (typeof match$1 === "number" || match$1.tag) {
                    return invalid_args("initialize");
                  } else {
                    var match$2 = param[1];
                    if (match$2 && !match$2[1]) {
                      var p = pack_proc(match$2[0]);
                      var array = $$Array.map(p, $$Array.map(Runtime_common$BwaxAdmin.pack_int, Belt_Array.range(0, match$1[0] - 1 | 0)));
                      return /* tuple */[
                              /* V_array */Caml_chrome_debugger.variant("V_array", 12, [array]),
                              Runtime_common$BwaxAdmin.nt
                            ];
                    } else {
                      return invalid_args("initialize");
                    }
                  }
                }
              } else {
                return invalid_args("initialize");
              }
            }))
    ],
    /* :: */Caml_chrome_debugger.simpleVariant("::", [
        /* tuple */[
          "repeat",
          Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                  if (param) {
                    var match = param[0][0];
                    if (typeof match === "number" || match.tag !== /* V_literal */5) {
                      return invalid_args("repeat");
                    } else {
                      var match$1 = match[0];
                      if (typeof match$1 === "number" || match$1.tag) {
                        return invalid_args("repeat");
                      } else {
                        var match$2 = param[1];
                        if (match$2 && !match$2[1]) {
                          var array = Belt_Array.make(match$1[0], match$2[0]);
                          return /* tuple */[
                                  /* V_array */Caml_chrome_debugger.variant("V_array", 12, [array]),
                                  Runtime_common$BwaxAdmin.nt
                                ];
                        } else {
                          return invalid_args("repeat");
                        }
                      }
                    }
                  } else {
                    return invalid_args("repeat");
                  }
                }))
        ],
        /* :: */Caml_chrome_debugger.simpleVariant("::", [
            /* tuple */[
              "fromList",
              Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
                      if (param) {
                        var match = param[0][0];
                        if (typeof match === "number" || !(match.tag === /* V_list */1 && !param[1])) {
                          return invalid_args("fromList");
                        } else {
                          var array = Curry._1(Plate$BwaxAdmin.List.to_array, match[0]);
                          return /* tuple */[
                                  /* V_array */Caml_chrome_debugger.variant("V_array", 12, [array]),
                                  Runtime_common$BwaxAdmin.nt
                                ];
                        }
                      } else {
                        return invalid_args("fromList");
                      }
                    }))
            ],
            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                /* tuple */[
                  "isEmpty",
                  Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
                          if (param) {
                            var match = param[0][0];
                            if (typeof match === "number" || !(match.tag === /* V_array */12 && !param[1])) {
                              return invalid_args("isEmpty");
                            } else {
                              return Runtime_common$BwaxAdmin.pack_bool(match[0].length === 0);
                            }
                          } else {
                            return invalid_args("isEmpty");
                          }
                        }))
                ],
                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                    /* tuple */[
                      "length",
                      Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
                              if (param) {
                                var match = param[0][0];
                                if (typeof match === "number" || !(match.tag === /* V_array */12 && !param[1])) {
                                  return invalid_args("length");
                                } else {
                                  return Runtime_common$BwaxAdmin.pack_int(match[0].length);
                                }
                              } else {
                                return invalid_args("length");
                              }
                            }))
                    ],
                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        /* tuple */[
                          "get",
                          Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                  if (param) {
                                    var match = param[0][0];
                                    if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                      return invalid_args("get");
                                    } else {
                                      var match$1 = match[0];
                                      if (typeof match$1 === "number" || match$1.tag) {
                                        return invalid_args("get");
                                      } else {
                                        var match$2 = param[1];
                                        if (match$2) {
                                          var match$3 = match$2[0][0];
                                          if (typeof match$3 === "number" || !(match$3.tag === /* V_array */12 && !match$2[1])) {
                                            return invalid_args("get");
                                          } else {
                                            return Runtime_common$BwaxAdmin.pack_maybe((function (x) {
                                                          return x;
                                                        }), Belt_Array.get(match$3[0], match$1[0]));
                                          }
                                        } else {
                                          return invalid_args("get");
                                        }
                                      }
                                    }
                                  } else {
                                    return invalid_args("get");
                                  }
                                }))
                        ],
                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                            /* tuple */[
                              "set",
                              Runtime_common$BwaxAdmin.pack_func(3, (function (param) {
                                      if (param) {
                                        var match = param[0][0];
                                        if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                          return invalid_args("set");
                                        } else {
                                          var match$1 = match[0];
                                          if (typeof match$1 === "number" || match$1.tag) {
                                            return invalid_args("set");
                                          } else {
                                            var match$2 = param[1];
                                            if (match$2) {
                                              var match$3 = match$2[1];
                                              if (match$3) {
                                                var original = match$3[0];
                                                var match$4 = original[0];
                                                if (typeof match$4 === "number" || !(match$4.tag === /* V_array */12 && !match$3[1])) {
                                                  return invalid_args("set");
                                                } else {
                                                  var new_arr = Curry._1(Plate$BwaxAdmin.List.to_array, Curry._1(Plate$BwaxAdmin.List.from_array, match$4[0]));
                                                  var updated = Belt_Array.set(new_arr, match$1[0], match$2[0]);
                                                  if (updated) {
                                                    return /* tuple */[
                                                            /* V_array */Caml_chrome_debugger.variant("V_array", 12, [new_arr]),
                                                            Runtime_common$BwaxAdmin.nt
                                                          ];
                                                  } else {
                                                    return original;
                                                  }
                                                }
                                              } else {
                                                return invalid_args("set");
                                              }
                                            } else {
                                              return invalid_args("set");
                                            }
                                          }
                                        }
                                      } else {
                                        return invalid_args("set");
                                      }
                                    }))
                            ],
                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                /* tuple */[
                                  "push",
                                  Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                          if (param) {
                                            var match = param[1];
                                            if (match) {
                                              var match$1 = match[0][0];
                                              if (typeof match$1 === "number" || !(match$1.tag === /* V_array */12 && !match[1])) {
                                                return invalid_args("push");
                                              } else {
                                                var array = Belt_Array.concat(match$1[0], /* array */[param[0]]);
                                                return /* tuple */[
                                                        /* V_array */Caml_chrome_debugger.variant("V_array", 12, [array]),
                                                        Runtime_common$BwaxAdmin.nt
                                                      ];
                                              }
                                            } else {
                                              return invalid_args("push");
                                            }
                                          } else {
                                            return invalid_args("push");
                                          }
                                        }))
                                ],
                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                    /* tuple */[
                                      "append",
                                      Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                              if (param) {
                                                var match = param[0][0];
                                                if (typeof match === "number" || match.tag !== /* V_array */12) {
                                                  return invalid_args("append");
                                                } else {
                                                  var match$1 = param[1];
                                                  if (match$1) {
                                                    var match$2 = match$1[0][0];
                                                    if (typeof match$2 === "number" || !(match$2.tag === /* V_array */12 && !match$1[1])) {
                                                      return invalid_args("append");
                                                    } else {
                                                      var array = Belt_Array.concat(match[0], match$2[0]);
                                                      return /* tuple */[
                                                              /* V_array */Caml_chrome_debugger.variant("V_array", 12, [array]),
                                                              Runtime_common$BwaxAdmin.nt
                                                            ];
                                                    }
                                                  } else {
                                                    return invalid_args("append");
                                                  }
                                                }
                                              } else {
                                                return invalid_args("append");
                                              }
                                            }))
                                    ],
                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                        /* tuple */[
                                          "slice",
                                          Runtime_common$BwaxAdmin.pack_func(3, (function (param) {
                                                  if (param) {
                                                    var match = param[0][0];
                                                    if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                                      return invalid_args("slice");
                                                    } else {
                                                      var match$1 = match[0];
                                                      if (typeof match$1 === "number" || match$1.tag) {
                                                        return invalid_args("slice");
                                                      } else {
                                                        var match$2 = param[1];
                                                        if (match$2) {
                                                          var match$3 = match$2[0][0];
                                                          if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
                                                            return invalid_args("slice");
                                                          } else {
                                                            var match$4 = match$3[0];
                                                            if (typeof match$4 === "number" || match$4.tag) {
                                                              return invalid_args("slice");
                                                            } else {
                                                              var match$5 = match$2[1];
                                                              if (match$5) {
                                                                var match$6 = match$5[0][0];
                                                                if (typeof match$6 === "number" || !(match$6.tag === /* V_array */12 && !match$5[1])) {
                                                                  return invalid_args("slice");
                                                                } else {
                                                                  var arr = match$6[0];
                                                                  var length = arr.length;
                                                                  var normalize = function (v) {
                                                                    if (v === length) {
                                                                      return length;
                                                                    } else {
                                                                      return Plate$BwaxAdmin.mod_by(length, v);
                                                                    }
                                                                  };
                                                                  var ns = normalize(match$1[0]);
                                                                  var ne = normalize(match$4[0]);
                                                                  var array = Belt_Array.slice(arr, ns, ne - ns | 0);
                                                                  return /* tuple */[
                                                                          /* V_array */Caml_chrome_debugger.variant("V_array", 12, [array]),
                                                                          Runtime_common$BwaxAdmin.nt
                                                                        ];
                                                                }
                                                              } else {
                                                                return invalid_args("slice");
                                                              }
                                                            }
                                                          }
                                                        } else {
                                                          return invalid_args("slice");
                                                        }
                                                      }
                                                    }
                                                  } else {
                                                    return invalid_args("slice");
                                                  }
                                                }))
                                        ],
                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                            /* tuple */[
                                              "toList",
                                              Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
                                                      if (param) {
                                                        var match = param[0][0];
                                                        if (typeof match === "number" || !(match.tag === /* V_array */12 && !param[1])) {
                                                          return invalid_args("toList");
                                                        } else {
                                                          return Runtime_common$BwaxAdmin.pack_list(Curry._1(Plate$BwaxAdmin.List.from_array, match[0]));
                                                        }
                                                      } else {
                                                        return invalid_args("toList");
                                                      }
                                                    }))
                                            ],
                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                /* tuple */[
                                                  "toIndexedList",
                                                  Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
                                                          if (param) {
                                                            var match = param[0][0];
                                                            if (typeof match === "number" || !(match.tag === /* V_array */12 && !param[1])) {
                                                              return invalid_args("toIndexedList");
                                                            } else {
                                                              return Runtime_common$BwaxAdmin.pack_list(Plate$BwaxAdmin.List.indexed_map((function (i, v) {
                                                                                return Runtime_common$BwaxAdmin.pack_tuple(/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                              Runtime_common$BwaxAdmin.pack_int(i),
                                                                                              /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                                  v,
                                                                                                  /* [] */0
                                                                                                ])
                                                                                            ]));
                                                                              }), Curry._1(Plate$BwaxAdmin.List.from_array, match[0])));
                                                            }
                                                          } else {
                                                            return invalid_args("toIndexedList");
                                                          }
                                                        }))
                                                ],
                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                    /* tuple */[
                                                      "map",
                                                      Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                                              if (param) {
                                                                var match = param[1];
                                                                if (match) {
                                                                  var match$1 = match[0][0];
                                                                  if (typeof match$1 === "number" || !(match$1.tag === /* V_array */12 && !match[1])) {
                                                                    return invalid_args("map");
                                                                  } else {
                                                                    var array = Belt_Array.map(match$1[0], pack_proc(param[0]));
                                                                    return /* tuple */[
                                                                            /* V_array */Caml_chrome_debugger.variant("V_array", 12, [array]),
                                                                            Runtime_common$BwaxAdmin.nt
                                                                          ];
                                                                  }
                                                                } else {
                                                                  return invalid_args("map");
                                                                }
                                                              } else {
                                                                return invalid_args("map");
                                                              }
                                                            }))
                                                    ],
                                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                        /* tuple */[
                                                          "indexedMap",
                                                          Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                                                  if (param) {
                                                                    var match = param[1];
                                                                    if (match) {
                                                                      var match$1 = match[0][0];
                                                                      if (typeof match$1 === "number" || !(match$1.tag === /* V_array */12 && !match[1])) {
                                                                        return invalid_args("indexedMap");
                                                                      } else {
                                                                        var f = param[0];
                                                                        var proc = function (i, v) {
                                                                          return Lang_eval$BwaxAdmin.apply_value_args(module_name, f, /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                        Runtime_common$BwaxAdmin.pack_int(i),
                                                                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                            v,
                                                                                            /* [] */0
                                                                                          ])
                                                                                      ]), Runtime_common$BwaxAdmin.nt);
                                                                        };
                                                                        var array = Belt_Array.mapWithIndex(match$1[0], proc);
                                                                        return /* tuple */[
                                                                                /* V_array */Caml_chrome_debugger.variant("V_array", 12, [array]),
                                                                                Runtime_common$BwaxAdmin.nt
                                                                              ];
                                                                      }
                                                                    } else {
                                                                      return invalid_args("indexedMap");
                                                                    }
                                                                  } else {
                                                                    return invalid_args("indexedMap");
                                                                  }
                                                                }))
                                                        ],
                                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                            /* tuple */[
                                                              "foldl",
                                                              Runtime_common$BwaxAdmin.pack_func(3, (function (param) {
                                                                      if (param) {
                                                                        var match = param[1];
                                                                        if (match) {
                                                                          var match$1 = match[1];
                                                                          if (match$1) {
                                                                            var match$2 = match$1[0][0];
                                                                            if (typeof match$2 === "number" || !(match$2.tag === /* V_array */12 && !match$1[1])) {
                                                                              return invalid_args("foldl");
                                                                            } else {
                                                                              var f = param[0];
                                                                              var proc = function (acc, v) {
                                                                                return Lang_eval$BwaxAdmin.apply_value_args(module_name, f, /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                              acc,
                                                                                              /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                                  v,
                                                                                                  /* [] */0
                                                                                                ])
                                                                                            ]), Runtime_common$BwaxAdmin.nt);
                                                                              };
                                                                              return Belt_Array.reduce(match$2[0], match[0], proc);
                                                                            }
                                                                          } else {
                                                                            return invalid_args("foldl");
                                                                          }
                                                                        } else {
                                                                          return invalid_args("foldl");
                                                                        }
                                                                      } else {
                                                                        return invalid_args("foldl");
                                                                      }
                                                                    }))
                                                            ],
                                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                /* tuple */[
                                                                  "foldr",
                                                                  Runtime_common$BwaxAdmin.pack_func(3, (function (param) {
                                                                          if (param) {
                                                                            var match = param[1];
                                                                            if (match) {
                                                                              var match$1 = match[0][0];
                                                                              if (typeof match$1 === "number" || match$1.tag !== /* V_array */12) {
                                                                                return invalid_args("foldr");
                                                                              } else {
                                                                                var match$2 = match[1];
                                                                                if (match$2 && !match$2[1]) {
                                                                                  var f = param[0];
                                                                                  var proc = function (acc, v) {
                                                                                    return Lang_eval$BwaxAdmin.apply_value_args(module_name, f, /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                                  v,
                                                                                                  /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                                      acc,
                                                                                                      /* [] */0
                                                                                                    ])
                                                                                                ]), Runtime_common$BwaxAdmin.nt);
                                                                                  };
                                                                                  return Belt_Array.reduceReverse(match$1[0], match$2[0], proc);
                                                                                } else {
                                                                                  return invalid_args("foldr");
                                                                                }
                                                                              }
                                                                            } else {
                                                                              return invalid_args("foldr");
                                                                            }
                                                                          } else {
                                                                            return invalid_args("foldr");
                                                                          }
                                                                        }))
                                                                ],
                                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                    /* tuple */[
                                                                      "filter",
                                                                      Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                                                              if (param) {
                                                                                var match = param[1];
                                                                                if (match) {
                                                                                  var match$1 = match[0][0];
                                                                                  if (typeof match$1 === "number" || !(match$1.tag === /* V_array */12 && !match[1])) {
                                                                                    return invalid_args("filter");
                                                                                  } else {
                                                                                    var array = Belt_Array.keep(match$1[0], pack_predicate(param[0]));
                                                                                    return /* tuple */[
                                                                                            /* V_array */Caml_chrome_debugger.variant("V_array", 12, [array]),
                                                                                            Runtime_common$BwaxAdmin.nt
                                                                                          ];
                                                                                  }
                                                                                } else {
                                                                                  return invalid_args("filter");
                                                                                }
                                                                              } else {
                                                                                return invalid_args("filter");
                                                                              }
                                                                            }))
                                                                    ],
                                                                    /* [] */0
                                                                  ])
                                                              ])
                                                          ])
                                                      ])
                                                  ])
                                              ])
                                          ])
                                      ])
                                  ])
                              ])
                          ])
                      ])
                  ])
              ])
          ])
      ])
  ]);

var external_vals = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    external_vals_000,
    external_vals_001
  ]);

var externals_000 = module_name;

var externals = /* tuple */[
  externals_000,
  external_vals
];

exports.module_name = module_name;
exports.src = src;
exports.invalid_args = invalid_args;
exports.pack_array = pack_array;
exports.pack_proc = pack_proc;
exports.pack_predicate = pack_predicate;
exports.external_vals = external_vals;
exports.externals = externals;
/* src Not a pure module */
